module.exports = __webpack_public_path__ + "img/banner.ec1212f.png";